import { useState } from 'react'

import { Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'
import { type ISectionRulesWrapper, type IRuleSection } from '@App/types/servicesTypes'

import { AddFields } from './AddFields/AddFields'
import { Buttons } from './Buttons/Buttons'
import style from './RulesOptions.module.scss'

interface IProps {
    isFetching: boolean
    sectionRules: ISectionRulesWrapper
    showAdd: boolean
    setShowAdd: (showAdd: boolean) => void
    setChosen: (chosen: IRuleSection | null) => void
    onSetSectionRules: (sectionRules: ISectionRulesWrapper | null) => void
    onChangeRules: (dto: ISectionRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const RulesOptions = (props: IProps) => {
    const { isFetching, sectionRules, showAdd, setShowAdd, setChosen, onChangeRules, onSetSectionRules } = props

    const [title, setTitle] = useState<string>('')
    const [description, setDescription] = useState<string>('')

    return (
        <div className={style.container}>
            {!showAdd &&
                sectionRules.sections.map((rule) => (
                    <div className={style.ruleOption} key={rule.title}>
                        <span>{rule.title}</span>
                        <div className={style.btn} onClick={() => setChosen(rule)}>
                            <Icon iconName={EIcons.AROW} width='7' height='12' />
                        </div>
                    </div>
                ))}
            {showAdd && (
                <AddFields
                    setShowAdd={setShowAdd}
                    title={title}
                    setTitle={setTitle}
                    description={description}
                    setDescription={setDescription}
                />
            )}
            <Buttons
                isFetching={isFetching}
                showAdd={showAdd}
                parentId={sectionRules.id}
                title={title}
                description={description}
                sections={sectionRules.sections}
                onSetAddMode={() => setShowAdd(true)}
                onSetSectionRules={onSetSectionRules}
                onChangeRules={onChangeRules}
            />
        </div>
    )
}
